import type { CTAStyling } from '@backmarket/http-api/src/api-specs-content/shared/cta-styling'
import { tw } from '@backmarket/utils/string/tw'
import type { Maybe } from '@backmarket/utils/types/Maybe'

export function getCTAColors(ctaStyling?: Maybe<CTAStyling>) {
  if (ctaStyling === 'secondary') {
    return { button: tw`mood-inverse`, text: tw`mood-main` }
  }

  return { button: tw`mood-main`, text: tw`mood-inverse` }
}
